import DataTable from 'datatables.net-react';
import { useEffect, useState } from 'react';
import { Button, Card, Col, Form, Modal, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { RateOfPointService } from '../../services/RateOfPointService';
import * as BullCache from "../../util/BullCache";
import MarketDropdown from '../components/MarketDropdown';
import ScriptDropdown from '../components/ScriptDropdown';

function RateOfPoint() {

    var allScripts = BullCache.getFromCache('allScripts');
    var user = BullCache.getFromCache("user");

    const navigate = useNavigate();

    const [loading, setLoading] = useState(false); 
    const [selectedMarket, setSelectedMarket] = useState('');  
    const [selectedScript, setSelectedScript] = useState('');  
    const [file, setFile] = useState(null);  
    const [rateOfPointList, setRateOfPointList] = useState([]);
    const [filteredRateOfPointList, setFilteredRateOfPointList] = useState([]);
    const [selectedItem, setSelectedItem] = useState([]);
    const [showModal, setShowModal] = useState(false);


    const fetchRateOfPointList = () => {
      setLoading(true);
        RateOfPointService.getRateOfPoint({ 'adminId': user.adminId }).then(res => {
        setLoading(false);
            if (res.code === 1) {
                const allLists = Object.values(res.data.rateOfPointList).flat();
                setRateOfPointList(allLists);
                setFilteredRateOfPointList(allLists);
            }
        });
    };

    useEffect(() => {
        fetchRateOfPointList();  
    }, []);  




    const handleMarketChange = (market) => {
        setSelectedMarket(market); 
    };

    const handleScriptChange = (script) => {
        setSelectedScript(script); 
    };

    const handleFileChange = (event) => {
        setFile(event.target.files[0]);
    };

    const handleClose = () => {
        setShowModal(false);
    };

    const handleAdd = () => {
        navigate('/addrateofpoint'); 
      };
    
      const handleScriptReset = () => {
        setSelectedScript(null); 
      };

    useEffect(() => {
        const handleEditClick = (event) => {
           
            const rowId = event.target.getAttribute("data-id");
            const rowData = filteredRateOfPointList[rowId]; 
            setSelectedItem(rowData);
            setShowModal(true);  
        };

        document.addEventListener("click", (event) => {
            if (event.target.classList.contains("icon-pencil")) {
                handleEditClick(event);
            }
        });

        return () => {
            document.removeEventListener("click", handleEditClick);
        };
    }, [filteredRateOfPointList]);  

    const handleUpload = () => {
        if (file) {          
            const formData = new FormData();
            formData.append("rateOfPointFile", file); 
            setLoading(true);
            RateOfPointService.uploadRateOfPoint(formData)
                .then(res => {
            setLoading(false);
                    if (res.code === 1) {
                        Swal.fire({
                            icon: "success",
                            text: "File Uploaded Successfully!!.."
                        });
                        setFile(null); 
                        document.getElementById('fileInput').value = ''; 

                        fetchRateOfPointList();
                    }
                })
                .catch(error => {
                    alert('Error: ' + error.message);  
                });
    
        } else {
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Please Select a File!",
            });
            return;
        }
    };
    

    const handleSaveChanges = () => {
        const selectedData = {
            adminId: user.adminId,
            segment: selectedItem.segment,
            symbol: selectedItem.symbol,
            quantity: selectedItem.quantity
        };
           
        const updatedList = rateOfPointList.map(item => {
            if (item.symbol === selectedData.symbol && item.segment === selectedData.segment) {
                return { ...item, quantity: selectedData.quantity }; 
            }
            return item;
        });

        const updatedFilteredList = filteredRateOfPointList.map(item => {
            if (item.symbol === selectedData.symbol && item.segment === selectedData.segment) {
                return { ...item, quantity: selectedData.quantity };  
            }
            return item;
        });
    
        setFilteredRateOfPointList(updatedFilteredList); 
        setRateOfPointList(updatedList);      
        
        RateOfPointService.updateRateOfPoint(selectedData)
            .then(res => {
                if (res.code === 1) {
                    Swal.fire({
                        icon: "success",
                        text: "Updated Successfully!!.."
                    });
                    setShowModal(false); 
                }
            })
            .catch(error => {              
                alert('Error updating data.'); 
            });
    };

    const handleSearch = () => {        
        setLoading(true);
        const filteredData = rateOfPointList.filter(item => {
            return (
                (selectedMarket ? item.segment === selectedMarket : true) &&
                (selectedScript ? item.symbol === selectedScript : true)
            );
        });
        setTimeout(() => {
            setFilteredRateOfPointList(filteredData);
             setLoading(false);
        }, 1000); 
       
    };

    const columns = [
        {
            title: "MARKET",
            data: "segment",
            className: "font-bold fss-1 ",
        },
        {
            title: "SCRIPT",
            data: "symbol",
            className: "font-bold fss-1 ",
        },
        {
            title: "LOT",
            data: "lot",
            className: "font-bold fss-1 ",
        },
        {
            title: "QTY",
            data: "quantity",
            className: "font-bold fss-1 ",
        },
        {
            title: "LAST UPDATED",
            data: "auditTimestamp",
            className: "font-bold fss-1 ",
        },
        {
            title: "EDIT",
            className: " font-bold fss-1 ",
            render: (data, type, row, full, meta) => {
              return `
              <i class="me-3 fa fa-pencil icon-pencil" data-id="${full.row}" style="cursor: pointer"></i>
            `;
            },
          }, 
    ]

    return (
        <div>
            <Card className='mt-2'>
                <Card.Body>
                    <Row>
                        <Col sm={3} xs={8}>
                        <Form.Group controlId="formFile">
                                <Form.Label><b className="fss-05">UPLOAD FILE</b></Form.Label>
                                <Form.Control
                                    id="fileInput"  
                                    className='bg-light text-black'
                                    type="file"
                                    onChange={handleFileChange}
                                    size="sm"
                                />
                            </Form.Group>
                        </Col>  
                        
                        <Col className=' mt-2' sm={3} xl={2} xs={4}>
                            <Button variant="success" size="sm " className='mt-4 ' onClick={handleUpload}>
                                Upload
                            </Button>
                        </Col>

                        <Col className=' mt-2' sm={2} xs={6}>
                        <b className='fss-05'>MARKET</b>                        
                            <MarketDropdown
                                allScripts={allScripts}
                                onMarketChange={handleMarketChange}
                                onScriptReset={handleScriptReset} />
                        </Col>

                        <Col className=' mt-2' sm={2} xs={6}>
                        <b className='fss-05'>SCRIPT NAME</b>
                        
                            <ScriptDropdown
                                allScripts={allScripts}
                                selectedMarket={selectedMarket}
                                onScriptChange={handleScriptChange}
                            />
                        </Col>

                        <Col sm={4} xl={3} className='mt-2'>
                            <Button variant="success" size="sm " className='mt-4 me-3' onClick={handleSearch}>
                                Search
                            </Button>

                            <Button variant="success" size="sm " className='mt-4' onClick={handleAdd}>
                                Add RateOfPoint
                            </Button>
                        </Col>
                    </Row>

                </Card.Body>
            </Card>

            <Card className="mt-2">
                <Card.Body>
                    <div className="table-responsive">
                        {loading ? (
                            <div className="container vh-100">
                                <div className="d-flex align-items-center justify-content-center h-90">
                                    <div className="spinner-border text-secondary m-5" role="status" style={{ width: '4rem', height: '4rem' }}>
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <DataTable
                                id="table"
                                className="table table-bordered bg-head-secondary fss-08 white-bordered-table"
                                columns={columns}
                                data={filteredRateOfPointList}
                                keyField="symbol"
                            />
                        )}
                    </div>
                </Card.Body>
            </Card>


            <Modal show={showModal} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Edit RateOfPoint</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedItem && (
                        <Form>
                            <Form.Group controlId="formMarket">
                            <Row>
                                <Col sm="2">
                                    <Form.Label>Market:</Form.Label></Col>
                                <Col sm="2">
                                    <Form.Label className='fss-09'>{selectedItem.segment}</Form.Label>
                                </Col>
                                <Col sm="2">
                                    <Form.Label>Script:</Form.Label></Col>
                                <Col sm="2">
                                    <Form.Label className='fss-09'>{selectedItem.symbol}</Form.Label>
                                </Col>
                            </Row> 
                            </Form.Group>

                            <Form.Group controlId="formQuantity" className="align-items-center">
                                <Row>
                                    <Col sm="2" className='pt-2'>
                                        <Form.Label >Quantity:</Form.Label></Col>
                                    <Col sm="5">
                                        <Form.Control
                                            type="number"
                                            value={selectedItem.quantity}
                                            onChange={(e) => {
                                                setSelectedItem({ ...selectedItem, quantity: e.target.value });
                                            }}
                                        />
                                    </Col>
                                </Row>
                            </Form.Group>
                        </Form>
                    )}
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="danger" onClick={handleClose}>
                        Close
                    </Button>
                    <Button variant="success" onClick={handleSaveChanges}>
                        Update
                    </Button>
                </Modal.Footer>
            </Modal>

        </div>
    );
}
export default RateOfPoint;